import 'core-js/es/object/entries';
import 'core-js/es/array/find';
import 'core-js/es/array/find-index';
import 'core-js/es/array/includes';
import 'core-js/es/string/includes';

import preact from 'preact';
import React from 'react';
import ReactDOM from 'react-dom';
import MessageModal from './Main/MessageModal';
import ReactBuySellFlow from './ReactBuySellFlow/ReactBuySellFlow';
import ProposalAudioPlayer from './Proposal/AudioPlayer';
import {SellQuestionsModal, BuyQuestionsModal, /*NewBuyQuestionsModal,*/ AlsoBuyingQuestionsModal} from './ReactBuySellFlow/QuestionsModal';
import EditProperty from './EditProperty';
import MessageAgentModal from './Proposal/MessageAgentModal';
import MessageAgentSuccessModal from './Proposal/MessageAgentSuccessModal';
import RequestCallModal from './Proposal/RequestCallModal';
import SelectAgentModal from './Proposal/SelectAgentModal';
import DeclineAgentModal from './Proposal/DeclineAgentModal';
import PromoteListingModal from './Proposal/PromoteListingModal';
import PromoteListingAlreadyListedProp from './Proposal/PromoteListingAlreadyListedProp';
import AlsoBuyingConfirmationModal from './Proposal/AlsoBuyingConfirmationModal';
import AlsoBuyingRejectionSurveyModal from './Proposal/AlsoBuyingRejectionSurveyModal';
import ClientFeedbackModal from './Proposal/ClientFeedbackModal';
import ClientCheckInSurvey from './ClientFeedback/ClientCheckInSurvey';
import ClientNPSSurvey from './ClientFeedback/ClientNPSSurvey';
import ThankYouForLettingUsKnowModal from "./Proposal/ThankYouForLettingUsKnowModal";
import AlsoSellingModal from "./Proposal/AlsoSellingModal";
import VirtualTourBanner from "./Proposal/VirtualTourBanner";
import Register from "./Register/Register";
import ProposalUnlockModal from './Proposal/ProposalUnlockModal';
import VerifyPhoneModal from './Proposal/VerifyPhoneModal';
import CallMeConfirmationModal from './Proposal/CallMeConfirmationModal';
import GiftCardPromoModal from './Unsubscribe/GiftCardPromoModal';
import HomeValueEstimatorRequestFlowModal from './HomeValueEstimatorRequestFlow/HVERequestFormModal';
// import UHLRates from './ReactBuySellFlow/UHLRates/UHLRates';
import VideoPlayerModal from './ReactBuySellFlow/VideoPlayerModal/VideoPlayerModal';
// import ModalPreQualified from './ReactBuySellFlow/PreQualified/ModalPreQualified';
import ProceedsCalculator from './ProceedsCalculator/ProceedsCalculator';
import AgentTransactions from './AgentTransactions/Transactions';

window.preact = preact;
window.React = React;
window.ReactDOM = ReactDOM;
window.reactComponents = {
    ...window.reactComponents,
    MessageModal,
    ReactBuySellFlow,
    ProposalAudioPlayer,
    SellQuestionsModal,
    BuyQuestionsModal,
    // NewBuyQuestionsModal, TODO:: Remove UHL
    AlsoBuyingQuestionsModal,
    EditProperty,
    Proposal: {
        MessageAgentModal,
        MessageAgentSuccessModal,
        RequestCallModal,
        SelectAgentModal,
        DeclineAgentModal,
        PromoteListingModal,
        PromoteListingAlreadyListedProp,
        AlsoBuyingConfirmationModal,
        AlsoBuyingRejectionSurveyModal,
        ClientFeedbackModal,
        ClientCheckInSurvey,
        ClientNPSSurvey,
        ThankYouForLettingUsKnowModal,
        AlsoSellingModal,
        VirtualTourBanner,
        ProposalUnlockModal,
        VerifyPhoneModal,
        CallMeConfirmationModal
    },
    ClientCheckInSurvey,
    ClientNPSSurvey,
    Register,
    GiftCardPromoModal,
    HomeValueEstimatorRequestFlowModal,
    // UHLRates, TODO:: Remove UHL
    VideoPlayerModal,
    ProceedsCalculator,
    // ModalPreQualified, TODO:: Remove UHL
    AgentTransactions
};
